//common
import './common';

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Carousel } from './blocks/carousel';
import { EffectCoverflow, Navigation } from 'swiper';

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    // фикс отсутпа над слайдами
    // Если страница восстановлена из bfcache, перезагружаем её
    window.location.reload();
  }
});

addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
    
    
    ScrollTrigger.matchMedia({
        
        "(min-width: 768px) and (max-width: 1900px)": function () {
            const header = document.querySelector('.header-sticky')
            const smoothContent = document.querySelector('#smooth-content');
        
            function updateOffset() {
                const h = header.offsetHeight;
                smoothContent.style.paddingTop = `${h}px`;
                ScrollTrigger.refresh();
            }
        
            updateOffset();
            window.addEventListener('resize', updateOffset);
            ScrollSmoother.create({
                wrapper: "#smooth-wrapper",
                content: "#smooth-content",
                smooth: 1.2, // Плавность (аналог duration в Lenis)
                effects: true, // Включает крутые эффекты параллакса
            });

            const pinContainer = document.querySelector(".horizontal-pin-container");
            const boundary = document.querySelector(".scroll-boundary-container");
            const track = document.querySelector(".horizontal-track");

            if (!pinContainer || !boundary || !track) {
                console.warn("GSAP horizontal scroll elements not found.");
                return;
            }

            // Рассчитываем дистанцию, которую должен пройти трек
            const scrollDistance = () => track.scrollWidth - boundary.offsetWidth;

            // Если скроллить нечего, выходим
            if (scrollDistance() <= 0) {
                return;
            }

            gsap.to(track, {
                x: () => -scrollDistance(),
                ease: "none",

                scrollTrigger: {
                    trigger: pinContainer,
                    pin: pinContainer,
                    pinSpacing: true,
                    anticipatePin: 2,
                    scrub: 1,
                    start: () => "top " + (header ? header.offsetHeight : 0),

                    // Этот параметр гарантирует, что ПИН будет активен ровно столько,
                    // сколько нужно для завершения горизонтальной прокрутки.
                    // После этого секция автоматически "отпускается".
                    end: () => "+=" + scrollDistance(),

                    invalidateOnRefresh: true,
                }
            });

        }

    });

})
new class extends Carousel {
    getClasses() {
        return {
            ...super.getClasses(),
            carousel: 'product-swiper',
            buttonNext: 'swiper-button-next',
            buttonPrev: 'swiper-button-prev',
        }
    }

    getModules() {
        return [Navigation];
    }

    getSettings(item) {
        const settings = {
            ...super.getSettings(item),
            slidesPerView: 'auto',
            spaceBetween: -40,
            loop: false,
            autoplay: false,
            breakpoints: {
                768: {
                    spaceBetween: 0,
                },
            },
            // coverflowEffect: {
            //     scale: 0.3,
            //     rotate: 0,
            //     stretch: 0,
            //     depth: 1,
            //     modifier: 1,
            //     // slideShadows: true,
            // },
        }
        return  settings;
    }
}



window.addEventListener('load', () => {
    ScrollTrigger.refresh();
});
